import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import styles from './style.module.scss';

function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const { language } = i18n;

  const handleChangeLanguage = currentLanguage => {
    i18n.changeLanguage(currentLanguage);
  };

  return (
    <div className={styles.navbarLang}>
      <div>
        <button
          type="button"
          className={clsx(styles.lang, language === 'kk' && styles.kk)}
          value="kk"
          onClick={() => handleChangeLanguage('kk')}>
          Қаз
        </button>
      </div>
      <div>
        <button
          type="button"
          className={clsx(styles.lang, language === 'ru' && styles.ru)}
          value="ru"
          onClick={() => handleChangeLanguage('ru')}>
          Рус
        </button>
      </div>
      <div>
        <button
          type="button"
          className={clsx(styles.lang, language === 'en' && styles.en)}
          value="en"
          onClick={() => handleChangeLanguage('en')}>
          Eng
        </button>
      </div>
      <div>
        <button
          type="button"
          className={clsx(styles.lang, language === 'cn' && styles.cn)}
          value="cn"
          onClick={() => handleChangeLanguage('cn')}>
          中文
        </button>
      </div>
    </div>
  );
}

export default LanguageSwitcher;
